// Core imports
import * as React from 'react';

// Components imports
import Button from 'src/components/common/Button';

// Models imports Style and misc imports
import './MobileFilterMenu.scss';

export default class MobileFilterMenu extends React.Component<
  ICategoriesFilterProps,
  any
> {
  public render() {
    const { t } = this.props;
    const { cancel, clear } = this.props;
    const menuStatus = this.props.menuIsOpened ? 'opened' : 'closed';
    return (
      <div className={`mobile-filter-menu ${menuStatus}`}>
        <nav className="mobile-filter-menu--header">
          <div className="header--back-to-results">
            <div className="header--action" onClick={this.props.closeMenu}>
              <i className="rpds-backspace icon" />
              <p className="back-to-results">{t('common.backToResults')}</p>
            </div>
          </div>
        </nav>
        <div className="header--filters-filter-control">
          <span className="cancel" onClick={cancel}>
            {t('common.cancel')}
          </span>
          {/* <span className="filter-by">{t('common.filterBy')}</span> */}
          {/* <span className="clear" onClick={clear}>
            {t('common.clear') + ' ' + t('common.filters')}
          </span> */}
        </div>
        <div className="header--filters--content">{this.props.children}</div>
        <div className="mobile-filter-menu--save-filters">
          <Button
            buttonClass="primary-button"
            label={t('common.saveFilters')}
            textTransform="uppercase"
            width="100%"
            height="100%"
            action={this.props.handleSaveFilters}
          />
        </div>
      </div>
    );
  }
}

interface ICategoriesFilterProps {
  closeMenu(): void;
  handleSaveFilters(): void;
  clear(): void;
  cancel(): void;
  t: any;
  menuIsOpened: boolean;
}

interface ICategoriesFilterState {
  isMobile: boolean;
  mobileMenuOpened: boolean;
}
